import type { Dispatch, ReactElement, FunctionComponent} from 'react';
import { useCallback } from 'react';
import { useContext, createContext } from 'react'
import type { ISiteAction} from './useSiteReducer';
import { ISiteTypes } from './useSiteReducer'



export interface ISiteContextState {
  nav:{
    sticky: boolean
  }
}

interface ISiteContextType {
  state: ISiteContextState,
  dispatch: Dispatch<ISiteAction>
}

export const siteInitialState: ISiteContextState  = {
  nav: {
    sticky: true
  }
}
// export const SiteContext = createContext<ISiteContextType>({
//   state: siteInitialState,
//   dispatch: () => null
// })
export const SiteContext = createContext<ISiteContextType | undefined>(undefined)
SiteContext.displayName = 'SiteContext'

const useSiteContext = () => {
  const context = useContext(SiteContext)
  if (!context) {
    throw new Error('useSiteContext must be used within a SiteContext Provider')
  }
  return context
}

/**
 * @Component useSite
 *
 * Primary context to contain global site data like users, site metadata, menus, etc.
 *
 * Currently used to track logged in Admin user as well as Resource Library user.
 *
 */
const useSite = () => {
  const {state, dispatch} = useSiteContext()

  return {
    state,
    dispatch
  }
}

export default useSite
